<div class="zoom-container">
    <mat-icon
        svgIcon="zoom-out"
        (mouseup)="onMouseUp()"
        (mousedown)="startInterval('minus')"
        (mouseleave)="onMouseUp()"
        style="cursor: pointer"></mat-icon>
    <div class="container">
        <input
            class="zoom-range"
            type="range"
            [min]="minValue"
            [max]="maxValue"
            [(ngModel)]="value"
            #zoomRange
            (input)="zoomRangeInput($event)" />
        <ng-container *ngIf="isFocus">
            <div class="input-value">
                {{ value + '%' }}
            </div>
        </ng-container>
    </div>
    <mat-icon
        svgIcon="zoom-in"
        (mouseup)="onMouseUp()"
        (mousedown)="startInterval('plus')"
        (mouseleave)="onMouseUp()"
        style="cursor: pointer"></mat-icon>
</div>
